module.exports = __webpack_public_path__ + "src/assets/img/button-tag.d1e98650.jpg";